import client from "@/lib/axios";
import { Account } from "@/features/accounts";
import {
  Credentials,
  LoginSuccessResponse,
  NewPasswordPayload,
  NewPasswordSuccessResponse,
  RecoveryEmailPayload,
  RecoveryEmailSuccessResponse,
} from "../../types";

export default {
  login: async ({ email, password }: Credentials): Promise<LoginSuccessResponse> => {
    const response = await client.post<LoginSuccessResponse>(
      "/login_check",
      { email, password },
      {
        headers: { "Content-Type": "application/json" },
      },
    );
    return response.data;
  },

  sendRecoveryEmail: async ({ email }: RecoveryEmailPayload): Promise<RecoveryEmailSuccessResponse> => {
    const data = new FormData();
    data.append("username", email);
    return client.post<RecoveryEmailSuccessResponse>("/lost-password/send-email", data, {
      headers: { "Content-Type": "multipart/form-data" },
    });
  },

  setNewPassword: async ({
    password,
    passwordToken,
    csrfToken,
  }: NewPasswordPayload): Promise<NewPasswordSuccessResponse> => {
    const data = new FormData();
    data.append("fos_user_resetting_form[plainPassword][first]", password);
    data.append("fos_user_resetting_form[plainPassword][second]", password);
    data.append("fos_user_resetting_form[_token]", csrfToken);
    const res = await client.post<NewPasswordSuccessResponse>(`/lost-password/reset/${passwordToken}`, data, {
      headers: { "Content-Type": "multipart/form-data" },
    });

    return res.data;
  },

  getAccountDetails: async (accountId: number | null) => {
    const response = await client.get<Account>(`/accounts/${accountId}`);
    return response.data;
  },

  logout: async () => {
    await client.post("/logout");
  },
};
